// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./dark-spinner@2x.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "._4qMUD7Iex{display:flex;justify-content:center}._1Y0XBf2ix{align-self:center;display:inline-block;flex:0 0 auto;opacity:1;text-indent:-99999px}@-webkit-keyframes _7v4f8IgSx{from{background-position:144px 0}to{background-position:0 0}}@keyframes _7v4f8IgSx{from{background-position:144px 0}to{background-position:0 0}}._3jT3clB0x{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:144px 12px;-webkit-animation:_7v4f8IgSx 1s infinite steps(12);animation:_7v4f8IgSx 1s infinite steps(12);height:12px;width:12px}@-webkit-keyframes _6S9z0gdUx{from{background-position:192px 0}to{background-position:0 0}}@keyframes _6S9z0gdUx{from{background-position:192px 0}to{background-position:0 0}}._6JK6Xf0Vx{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:192px 16px;-webkit-animation:_6S9z0gdUx 1s infinite steps(12);animation:_6S9z0gdUx 1s infinite steps(12);height:16px;width:16px}@-webkit-keyframes _1x0T9mQTx{from{background-position:240px 0}to{background-position:0 0}}@keyframes _1x0T9mQTx{from{background-position:240px 0}to{background-position:0 0}}.ZEGblXCxx{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:240px 20px;-webkit-animation:_1x0T9mQTx 1s infinite steps(12);animation:_1x0T9mQTx 1s infinite steps(12);height:20px;width:20px}@-webkit-keyframes _55h0nsXqx{from{background-position:384px 0}to{background-position:0 0}}@keyframes _55h0nsXqx{from{background-position:384px 0}to{background-position:0 0}}._2YttSXaIx{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:384px 32px;-webkit-animation:_55h0nsXqx 1s infinite steps(12);animation:_55h0nsXqx 1s infinite steps(12);height:32px;width:32px}@-webkit-keyframes _4HO2lV4dx{from{background-position:576px 0}to{background-position:0 0}}@keyframes _4HO2lV4dx{from{background-position:576px 0}to{background-position:0 0}}._2rNq87k3x{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:576px 48px;-webkit-animation:_4HO2lV4dx 1s infinite steps(12);animation:_4HO2lV4dx 1s infinite steps(12);height:48px;width:48px}@-webkit-keyframes _5fxhGRT4x{from{background-position:768px 0}to{background-position:0 0}}@keyframes _5fxhGRT4x{from{background-position:768px 0}to{background-position:0 0}}._49jAevDox{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:768px 64px;-webkit-animation:_5fxhGRT4x 1s infinite steps(12);animation:_5fxhGRT4x 1s infinite steps(12);height:64px;width:64px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_4qMUD7Iex",
	"spinner": "_1Y0XBf2ix",
	"xxsmall": "_3jT3clB0x",
	"xxsmallSpinnerRotation": "_7v4f8IgSx",
	"xsmall": "_6JK6Xf0Vx",
	"xsmallSpinnerRotation": "_6S9z0gdUx",
	"small": "ZEGblXCxx",
	"smallSpinnerRotation": "_1x0T9mQTx",
	"medium": "_2YttSXaIx",
	"mediumSpinnerRotation": "_55h0nsXqx",
	"large": "_2rNq87k3x",
	"largeSpinnerRotation": "_4HO2lV4dx",
	"xlarge": "_49jAevDox",
	"xlargeSpinnerRotation": "_5fxhGRT4x"
};
module.exports = exports;
